<template>
  <div>
    <!-- 顶部 -->
    <detailHeader />
    <!-- 追加商品弹窗 -->
    <addGoods ref="addGoods" />
    <div class="deliveryPreview">
      <headervue />
      <div class="table" :class="{ showAll: !showAllGoods }">
        <ol>
          <!-- 选择 -->
          <li class="flex05"></li>

          <li class="flex05">NO</li>
          <!-- 订单号 -->
          <li>{{ $t("message.orderNumber") }}</li>
          <!-- 番号 -->
          <li class="flex05">{{ $t("message.mash") }}</li>
          <!-- 产品 -->
          <li>{{ $t("message.product") }}</li>
          <!-- 商品规格 -->
          <li>{{ $t("message.productSpecifications") }}</li>
          <!-- 购入数据 -->
          <li>{{ $t("message.purchaseData") }}</li>
          <!-- 标签信息 -->
          <li>{{ $t("message.labelInformation") }}</li>
          <!-- 可提出数量 -->
          <li>{{ $t("message.quantitiesCanBeProposed") }}</li>
          <!-- 提货数量 -->
          <li>{{ $t("message.quantityAvailableDelivery") }}</li>
          <!-- 单番装箱备注 -->
          <li>{{ $t("message.singlePackingNotes") }}</li>
        </ol>
        <div
          v-for="(goodsItem, goodsIndex) in tableData"
          :key="'goods-row-' + goodsIndex"
          class="delivery-preview-group"
        >
          <ul>
          <!-- 选择 -->
          <li class="flex05 material-selection-cell">
            <!-- 辅料标识固定在当前商品行左上角 -->
            <materialMark :material="goodsItem.material" :material_id="goodsItem.material_id" />
            <el-checkbox v-model="goodsItem.checked" @change="checkOne"></el-checkbox>
          </li>
          <!-- NO -->
          <li class="flex05">{{ goodsIndex + 1 }}</li>
          <!-- 订单号 -->
          <li>{{ goodsItem.order_sn }}</li>
          <!-- 番号 -->
          <li class="flex05">{{ goodsItem.sorting }}</li>
          <!-- 产品 -->
          <li class="product">
            <el-popover placement="right" trigger="hover">
              <img :src="goodsItem.pic" alt="" style="width: 300px; height: 300px" />
              <el-image slot="reference" :src="goodsItem.pic" style="width: 80px; height: 80px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
            </el-popover>
            <p>
              {{ goodsItem.goods_title }}
            </p>
          </li>
          <!-- 商品规格 -->
          <li>
            <div class="tabInfomation">
              <el-popover placement="bottom" trigger="hover">
                <div class="orderDetailAll">
                  <div class="detailAllCon">
                    <p v-for="(detailItem, detailIndex) in goodsItem.detail" :key="detailIndex">
                      <span> {{ detailItem.key }}: </span>
                      <span>{{ detailItem.value }}</span>
                    </p>
                  </div>
                </div>
                <div class="goodsDetail " slot="reference">
                  <p v-for="(detailItem, detailIndex) in goodsItem.detail" :key="detailIndex">
                    <span> {{ detailItem.key }}: </span>
                    <span>{{ detailItem.value }}</span>
                  </p>
                </div>
              </el-popover>
            </div>

          </li>
          <!-- 购入数据 -->
          <li>
            <div>
              <p>
                <!-- 数量 -->
                <span>{{ $t("message.quantity") }}:</span>
                <span class="blurFont">
                  {{ goodsItem.confirm_num }}
                </span>
              </p>
              <p>
                <!-- 单价 -->
                <span>{{ $t("message.unitPrice") }}:</span>
                <span class="redFont">
                  {{ goodsItem.confirm_price }}
                </span>
              </p>
              <p>
                <!-- 国内运费 -->
                <span>{{ $t("message.domesticFreight") }}:</span>
                <span class="redFont">
                  {{ goodsItem.confirm_freight }}
                </span>
              </p>
              <p>
                <!-- 小计 -->
                <span>{{ $t("message.subtotal") }}:</span>
                <span class="blurFont">

                  {{
                    (
                      goodsItem.confirm_num * goodsItem.confirm_price +
                      (goodsItem.confirm_freight - 0)
                    ).toFixed(2)
                  }}
                </span>
              </p>
            </div>
          </li>
          <!-- 标签信息 -->
          <li>
            <!-- goodsItem.porder_freight_detail -->
            <div class="tabInfomation">
              <div class="item" v-for="(tag, tagIndex) in goodsItem.order_detail_tag" :key="tagIndex">
                <p>类别:{{ tag.type }}</p>
                <p>标签号:{{ tag.no }}</p>
                <p>商品码:{{ tag.goods_no }}</p>
              </div>
            </div>
          </li>
          <!-- 可提出数量 -->
          <li>{{ goodsItem.send_await_num }}</li>
          <!-- 提货数量 -->
          <li>
            <el-input class="numBox" size="mini" oninput="value=value.replace(/[^\d]/g,'')" v-model="goodsItem.send_num"
              @input="setNum(goodsItem)"></el-input>
          </li>
          <!-- 单番装箱备注 -->
          <li>
            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="goodsItem.client_remark">
            </el-input>
          </li>
          </ul>
          <!-- 当前商品绑定的辅料列表组件，支持收起和展开 -->
          <materialList
            :materials="goodsItem.materials"
            :send_num="goodsItem.send_num"
            :expanded.sync="goodsItem.materialsExpanded"
          />
        </div>
        <div class="showAllBtn" @click="showAllGoods = !showAllGoods" v-if="tableData.length > 2 && false">
          <!-- 展开/收起 -->
          {{ !showAllGoods ? $t("message.unfold") : $t("message.collapse") }}
        </div>
        <!-- 暂无数据 -->
        <div v-if="tableData == false" class="No_data">
          {{ $t("message.noDataYet") }}
        </div>
      </div>
      <!-- 操作栏 -->
      <div class="operate">
        <div class="leftBox">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="checkAll()">{{
            $t("message.allChecked")
          }}</el-checkbox>
          <!-- 追加 -->
          <el-button size="mini" type="primary" class="primary" @click="addData">
            {{ $t("message.additional") }}
          </el-button>
          <!-- 删除 -->
          <el-button size="mini" type="primary" class="primary" @click="deleteData">
            {{ $t("message.delete") }}
          </el-button>
        </div>
        <!-- 提出配送单 -->
        <div class="rightBox">
          <div>
            <div class="numberOfProducts">
              <!-- 商品种类 -->
              <span>{{ $t("message.items") }}:</span>
              <span class="redFont"> {{ tableData.length }} 件</span>
            </div>
            <div class="numberOfProducts">
              <!-- 提出数量 -->
              <span>{{ $t("message.proposeQuantities") }}:</span>
              <span class="redFont">{{ total }} 件</span>
            </div>
          </div>
          <!-- 提出配送单 -->
          <el-button size="mini" type="primary" class="fr" @click="porderCreate('send')">
            {{ $t("message.putForwardDeliveryOrder") }}
          </el-button>
        </div>
      </div>
      <footervue ref="footervue" />
    </div>
  </div>
</template>
<script>
import headervue from "./components/header.vue";
import detailHeader from "@/components/header/detailHeader";
import footervue from "./components/footer.vue";
import addGoods from "./components/addGoods.vue";
// 配送单预览页辅料标识组件
import materialMark from "./components/materialMark.vue";
// 配送单预览页辅料列表组件
import materialList from "./components/materialList.vue";
export default {
  components: {
    detailHeader,
    headervue,
    footervue,
    addGoods,
    materialMark,
    materialList,
  },
  metaInfo() {
    return {
      title: '帮客户提配送单',
    };
  },
  data() {
    return {
      previewData: {},
      tableData: [],
      showAllGoods: false,
      checked: false, //是否全选
      total: 0,
      user_id: this.$route.query.userID ? this.$route.query.userID : this.$route.query.porder_sn.split('-')[1],
    };
  },
  created() {
    let query = this.$route.query
    if (query.porder_sn) {
      this.porderDetail(query.porder_sn)
    }
    else {
      this.porderPreview();
    }

  },

  methods: {
    // 配送单预览
    porderDetail(porder_sn) {
      this.tableData = []
      this.$api.porderApi
        .porderDetail({
          porder_sn
        })
        .then((res) => {
          console.log(res);

          if (res.code != 0) return this.$message.error(res.data.msg);
          res.data.list.forEach((item) => {
            item.send_num = item.num;
            this.total += item.send_num - 0;
            item.confirm_num = item.num;
            item.confirm_freight = item.freight
            item.send_await_num = item.wait_freight_num,
            item.order_detail_tag = item.porder_detail_tag
            // 初始化辅料列表及展开状态，后续按商品加载绑定辅料
            item.materials = []
            item.materialsExpanded = true

          });


          this.$refs.footervue.logistics_id = res.data.logistics.id
          this.$refs.footervue.fileList = res.data.order_files
          this.$refs.footervue.client_remark = res.data.client_remark
          this.$refs.footervue.importer = {
            zip_code: res.data.importer.zip_code,
            contacts: res.data.importer.contacts,
            address: res.data.importer.address,
            standard_no: res.data.importer.standard_code,
            address_roma: res.data.importer.address_roma,
            contacts_roma: res.data.importer.contacts_roma,
            bank_no: res.data.importer.bank_no,
            tax_no: res.data.importer.tax_no,
            account: res.data.importer.bank_no,
            address_rome: res.data.importer.address_roma,
            company: res.data.importer.company,
            company_roma: res.data.importer.company_roma || '',
            corporate_name: res.data.importer.tax_no,
            mobile: res.data.importer.mobile,
            name: res.data.importer.contacts,
            name_rome: res.data.importer.contacts_roma,
            standard_code: res.data.importer.standard_code,
            tel: res.data.importer.mobile.tel,
            title: res.data.importer.mobile.title,
            zip: res.data.importer.zip_code,
          }
          this.$refs.footervue.receiver = {
            zip_code: res.data.receiver.zip_code,
            contacts: res.data.receiver.contacts,
            address: res.data.receiver.address,
            standard_no: res.data.receiver.standard_code,
            address_roma: res.data.receiver.address_roma,
            contacts_roma: res.data.receiver.contacts_roma,
            bank_no: res.data.receiver.bank_no,
            tax_no: res.data.receiver.tax_no,
            account: res.data.receiver.bank_no,
            address_rome: res.data.receiver.address_roma,
            company: res.data.receiver.company,
            company_roma: res.data.receiver.company_roma || '',
            corporate_name: res.data.receiver.tax_no,
            mobile: res.data.receiver.mobile,
            name: res.data.receiver.contacts,
            name_rome: res.data.receiver.contacts_roma,
            standard_code: res.data.receiver.standard_code,
            tel: res.data.receiver.mobile.tel,
            title: res.data.receiver.mobile.title,
            zip: res.data.receiver.zip_code,
          }
          this.previewData = res.data;
          this.tableData = res.data.list;
          this.loadMaterials()
        });
    },
    // 单选
    checkOne() {
      this.isAllChecked();
    },
    // 判断是否全选
    isAllChecked() {
      this.checked = this.tableData.every((item) => {
        return item.checked == true;
      });
    },
    // 删除商品
    deleteData() {
      // 是否确定删除？
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
        }
      )
        .then(() => {
          for (let i = 0; i < this.tableData.length; i++) {
            if (!!this.tableData[i].checked) {
              this.tableData.splice(i, 1);
              i--;
            }
          }
          this.checked = false;
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => { });
    },
    // 全選
    checkAll() {
      this.tableData.forEach((element) => {
        element.checked = this.checked;
      });
    },
    // 追加商品
    addData() {
      this.$refs.addGoods.open();
    },
    // 获取配送单预览数据
    porderPreview() {
      // 优先读取仓库预览弹框传递的完整 stock 参数
      let stock = []
      if (this.$route.query.stock) {
        try {
          stock = JSON.parse(decodeURIComponent(this.$route.query.stock))
        } catch (e) {
          stock = []
        }
      }
      // 兼容旧的 id 路由参数
      if (!stock.length && this.$route.query.id) {
        stock = this.$route.query.id.split(',').map(id => ({ order_detail_id: id }))
      }
      this.$api.clienteleApi
        .porderPreview({
          user_id: this.user_id,
          stock,
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(res.data.msg);
          res.data.porder_data.forEach((item) => {
            // 接口返回预览项按请求中的 prefill_num 回填本次提出数量
            const requestItem = stock.find(entry => String(entry.order_detail_id) === String(item.order_detail_id))
            item.send_num = requestItem && requestItem.prefill_num ? requestItem.prefill_num : item.send_await_num;
            this.total += item.send_num - 0;
          });
          this.previewData = res.data;
          this.tableData = res.data.porder_data;
          this.tableData.forEach(item => {
            // 初始化辅料列表及展开状态，后续按商品加载绑定辅料
            this.$set(item, 'materials', [])
            this.$set(item, 'materialsExpanded', true)
          })
          this.loadMaterials()
        });
    },
    // 限制数字输入框
    // 按商品加载绑定辅料详情，每个商品单独请求一次接口
    loadMaterials() {
      const items = this.tableData.filter(item => item.has_material_bind == 1 && Number(item.material_id || 0) === 0)
      if (!items.length) return
      Promise.all(items.map(item => this.$api.clienteleApi.stockMaterialBindList({
        user_id: this.user_id,
        order_detail_ids: [item.order_detail_id || item.id],
        max_ids: 50,
      }).then(res => {
        const detailId = item.order_detail_id || item.id
        const groups = Array.isArray(res.data) ? res.data : []
        const group = groups.find(entry => String(entry.order_detail_id) === String(detailId))
        const materials = (group && group.material_bind || []).map(material => ({
          ...material,
          checked: true,
        }))
        this.$set(item, 'materials', materials)
      })))
    },
    setNum(data) {
      if (data.send_num > data.send_await_num) {
        data.send_num = data.send_await_num;
        return
      }

      // 批量
      if (data.checked) {
        this.tableData.forEach((item) => {
          if (item.checked) {
            item.send_num = data.send_num
          }

        });
      }
      this.total = 0;
      this.tableData.forEach((item) => {
        this.total += item.send_num - 0;
      });
    },
    // 提出配送单
    porderCreate(create_type) {
      // 验证是否以选择物流方式
      if (!this.$refs.footervue.logistics_id) {
        // 请选择物流方式
        return this.$message.warning(
          this.$t("message.pleaseSelectTheLogisticsMethod")
        );
      }
      // 验证表单
      if (!this.$refs.footervue.registerCheck()) {
        return false;
      }
      this.tableData.forEach((element) => {
        element.order_detail_tag.forEach(item => {
          delete item.order_detail_id
        })
        element.porder_detail_tag = element.order_detail_tag
      });
      let porder_detail = []
      this.tableData.forEach(item => {
        porder_detail.push({
          order_detail_id: item.order_detail_id,
          send_num: item.send_num,
          client_remark: item.client_remark,
          porder_detail_tag: item.order_detail_tag
        })
      }

      )
      let data = {
        user_id: this.user_id, //客户ID
        create_type: create_type, //提出类型【save-临时保存，send-正式提出】
        porder_sn: this.previewData.porder_sn, //配送单号
        logistics_id: this.$refs.footervue.logistics_id, //物流方式id
        client_remark: this.$refs.footervue.client_remark, //客户备注
        block_email: this.$refs.footervue.block_email ? 1 : 0, //是否屏蔽邮件
        porder_detail, //表格数据
        porder_file: this.$refs.footervue.fileList, //配送单附件
        importer_address: this.$refs.footervue.importer, //用户地址
        receiver_address: this.$refs.footervue.receiver, //用户地址
      };
      console.log(data, this.previewData);
      this.$api.clienteleApi.porderCreate(data).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.$router.push(
          "/porderTranslate"
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.deliveryPreview {
  background: #f8f8f8;
  padding: 0 24px 24px;
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

// 辅料标识所在选择列作为左上角定位容器
.material-selection-cell {
  position: relative;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 12px;
  max-height: unset;
  position: relative;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    .tabInfomation {
      width: 100%;
      text-align: left;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .showAllBtn {
    position: sticky;
    bottom: 0;
    cursor: pointer;
    padding: 10px 20px;
    background-color: #edeff4;
    text-align: right;
    font-size: 15px;
    color: #444242;
  }
}

// 每个商品组使用真实元素承载 v-for 和 key，保持组内列表占满整行
.delivery-preview-group {
  width: 100%;
}

.table.showAll {
  // max-height: 500px;
  overflow: auto;
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.numBox {
  width: 100px;

  /deep/input {
    text-align: center;
  }
}

.product {
  p {
    margin-left: 10px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}

.goodsDetail {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.operate {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 9;
  padding: 16px 24px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .leftBox {
    display: flex;
    justify-content: center;
    align-items: center;

    >* {
      margin-right: 15px;
    }
  }

  .rightBox {
    display: flex;
    align-items: center;

    .numberOfProducts {
      margin-right: 40px;
    }
  }
}
</style>
